import React from 'react';
import Typography from '../atoms/Typography';
import styled from 'styled-components';

const InputSection = styled.div`
  border: 1px solid var(--color-border-primary);
  background: var(--color-bg-primary);
  border-radius: 8px;
  gap: 8px;
  padding: 3px 12px;

  box-shadow: var(--shadow-sm);
`;

const FormInput = ({
  label,
  isInputSection,
  children,
}: {
  label: string;
  isInputSection?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      <div
        style={{
          marginBottom: 4,
        }}
      >
        <Typography.Body type={'Label'}>{label}</Typography.Body>
      </div>
      {isInputSection && <InputSection>{children}</InputSection>}
      {!isInputSection && <>{children}</>}
    </div>
  );
};

export default FormInput;
